var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalEvent = function SvgCalEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cal_event_svg2__a",
    x1: 1.12,
    x2: 187.99,
    y1: 193.48,
    y2: 29.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__b",
    x1: 24.99,
    x2: 211.85,
    y1: 220.66,
    y2: 56.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__c",
    x1: 29.02,
    x2: 215.88,
    y1: 225.25,
    y2: 61.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__d",
    x1: -18.55,
    x2: 168.32,
    y1: 171.08,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__e",
    x1: -16.53,
    x2: 170.33,
    y1: 173.38,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__f",
    x1: -2.02,
    x2: 184.84,
    y1: 189.9,
    y2: 25.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__g",
    x1: 0,
    x2: 186.86,
    y1: 192.2,
    y2: 28.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__h",
    x1: 14.51,
    x2: 201.37,
    y1: 208.73,
    y2: 44.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__i",
    x1: 12.66,
    x2: 199.53,
    y1: 206.63,
    y2: 42.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__j",
    x1: 41.51,
    x2: 228.38,
    y1: 239.48,
    y2: 75.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__k",
    x1: 58.04,
    x2: 244.91,
    y1: 258.31,
    y2: 94.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_event_svg2__a",
    id: "cal_event_svg2__l",
    x1: 43.53,
    x2: 230.39,
    y1: 241.78,
    y2: 77.7
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.33 13.33h-20V10c0-5.52-4.48-10-10-10s-10 4.48-10 10v3.33H110V10c0-5.52-4.48-10-10-10S90 4.48 90 10v3.33H56.67V10c0-5.52-4.48-10-10-10s-10 4.48-10 10v3.33h-20C7.47 13.34.01 20.8 0 30v153.33c.01 9.2 7.47 16.66 16.67 16.67h166.67c9.2-.01 16.66-7.47 16.67-16.67V30c-.01-9.2-7.47-16.66-16.67-16.67ZM150 10c0-1.84 1.49-3.33 3.33-3.33s3.33 1.49 3.33 3.33v20c0 1.84-1.49 3.33-3.33 3.33S150 31.84 150 30zm-53.33 0c0-1.84 1.49-3.33 3.33-3.33s3.33 1.49 3.33 3.33v20c0 1.84-1.49 3.33-3.33 3.33s-3.33-1.49-3.33-3.33zm-53.34 0c0-1.84 1.49-3.33 3.33-3.33s3.33 1.49 3.33 3.33v20c0 1.84-1.49 3.33-3.33 3.33s-3.33-1.49-3.33-3.33zm150 173.33c0 5.52-4.48 9.99-10 10H16.67c-5.52 0-9.99-4.48-10-10V60h186.67v123.33Zm0-130H6.67V30c0-5.52 4.48-9.99 10-10h20v10c0 5.52 4.48 10 10 10s10-4.48 10-10V20H90v10c0 5.52 4.48 10 10 10s10-4.48 10-10V20h33.33v10c0 5.52 4.48 10 10 10s10-4.48 10-10V20h20c5.52 0 9.99 4.48 10 10z",
    style: {
      fill: "url(#cal_event_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33 103.33h13.33c1.84 0 3.33-1.49 3.33-3.33V86.67c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84 0-3.33 1.49-3.33 3.33V100c0 1.84 1.49 3.33 3.33 3.33M166.67 90h6.67v6.67h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 150H96.67c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33H110c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33m-3.33 13.33H100v-6.67h6.67z",
    style: {
      fill: "url(#cal_event_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.33 103.33h13.33c1.84 0 3.33-1.49 3.33-3.33V86.67c0-1.84-1.49-3.33-3.33-3.33H63.33c-1.84 0-3.33 1.49-3.33 3.33V100c0 1.84 1.49 3.33 3.33 3.33M66.67 90h6.67v6.67h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 136.67h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33H30c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.33-13.34H40V130h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.33 136.67h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33H63.33c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.34-13.34h6.67V130h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 170h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33H30c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.33-13.33H40v6.67h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.33 170h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33H63.33c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.34-13.33h6.67v6.67h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.11 115.16-2.88 17.64a3.33 3.33 0 0 0 2.76 3.82c.73.12 1.49-.01 2.14-.37l14.87-8.22 14.87 8.22c1.61.89 3.64.31 4.53-1.3.36-.65.49-1.41.37-2.15l-2.87-17.64 12.16-12.46a3.33 3.33 0 0 0-.05-4.71 3.3 3.3 0 0 0-1.83-.91s-16.67-2.54-16.67-2.54l-7.49-15.95a3.329 3.329 0 0 0-6.03 0l-7.48 15.95-16.67 2.55a3.333 3.333 0 0 0-2.79 3.8c.1.69.42 1.33.91 1.83l12.16 12.46Zm9.15-14.31c1.1-.17 2.04-.87 2.51-1.88l5.22-11.13 5.22 11.13a3.34 3.34 0 0 0 2.51 1.88l12.01 1.83-8.8 9.02c-.74.76-1.07 1.82-.9 2.86l2.04 12.52-10.47-5.79c-1-.55-2.22-.55-3.23 0l-10.47 5.79 2.04-12.52c.17-1.04-.17-2.11-.9-2.86l-8.8-9.02 12.01-1.83Z",
    style: {
      fill: "url(#cal_event_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33 136.67h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.34-13.34h6.67V130h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33 170h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.34-13.33h6.67v6.67h-6.67z",
    style: {
      fill: "url(#cal_event_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33 150H130c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33h13.33c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33M140 163.33h-6.67v-6.67H140z",
    style: {
      fill: "url(#cal_event_svg2__l)"
    }
  }));
};
export default SvgCalEvent;